import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import JobService from '@/core/services/job.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditJobComponent extends Vue {

  jobService: any = new JobService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  genericErr: any = [];
  companyList: any = [];
  name: string = "";
  companies: string = "defaultCompany";

  mounted (){
    const _ = this;
    _.getById();
    _.getCompanies();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  getCompanies(){
    const _ = this;
    _.isLoading = true;
    _.jobService.getCompanies().then((data: any) => {
      _.companyList = data['data'].companies;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      _.isLoading = false;
    })
  }

  edit(){
    const _ = this;
    let job = {
      name: _.name,
      companyId: _.companies
    };
    console.log(job);
    let idJob: any = location.href.split("/");
    idJob = idJob[5];
    _.isLoading = true;
    _.jobService.edit(job, idJob).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/job');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let idJob: any = location.href.split("/");
    idJob = idJob[5];
    _.isLoading = true;
    _.jobService.getById(idJob).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].job.name;
      _.companies = data["data"].job.companyId;
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(name = ''){
    const _ = this;
    _.genericErr = [];
    if(name == ''){
      _.genericErr.push("Por favor escribe el giro");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }
}
